import GreenAudioPlayer from  'green-audio-player/dist/js/green-audio-player'

export default {
    init() {
      // JavaScript to be fired on the contact page
    },
    finalize() {
        new GreenAudioPlayer('.js-player');
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-promo-page.js